var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-global-overlay overflow-y-scroll"},[_c('PortalTarget',{directives:[{name:"trap-focus",rawName:"v-trap-focus.loop",value:({
			active: _vm.hasContent,
		}),expression:"{\n\t\t\tactive: hasContent,\n\t\t}",modifiers:{"loop":true}}],class:[
			'c-global-overlay__target z-50',
			{ 'c-global-overlay__target--active': _vm.hasContent } ],attrs:{"id":("c-global-overlay-" + _vm._uid),"name":_vm.name},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }